export const SupraSolarProjects = [
  {
    slug: "zdencina",
    card: "/img/projects/suprasolar/zdencina.jpg",
    name: "FNE Zdenčina",
    services_list: "4166 kW",
    timeframe: "Donja Zdenčina",
  },
  {
    slug: "family-mall",
    card: "/img/projects/suprasolar/family-mall.jpg",
    name: "FNE Family Mall",
    services_list: "1500 kW",
    timeframe: "Zagreb",
  },
  {
    slug: "point",
    card: "/img/projects/suprasolar/point.jpg",
    name: "FNE F&D Point",
    services_list: "205 kW",
    timeframe: "Zagreb",
  },
  {
    slug: "tehnoguma",
    card: "/img/projects/suprasolar/tehnoguma-zabok.jpg",
    name: "FNE Tehnoguma 1",
    services_list: "100 kW",
    timeframe: "Zabok",
  },
  {
    slug: "arancin",
    card: "/img/projects/suprasolar/arancin.jpg",
    name: "FNE Hotel Arancini Residence",
    services_list: "70 kW",
    timeframe: "Vodice",
  },
  {
    slug: "vrbani3",
    card: "/img/projects/suprasolar/vrbani3.jpg",
    name: "FNE DV Vrbani III",
    services_list: "60 kW",
    timeframe: "Zagreb",
  },
  {
    slug: "medimar",
    card: "/img/projects/suprasolar/medimar.jpg",
    name: "FNE Dom Medimar",
    services_list: "60 kW",
    timeframe: "Sesvete",
  },
  {
    slug: "jerkic",
    card: "/img/projects/suprasolar/jerkic-vrsar.jpg",
    name: "FNE Jerkić",
    services_list: "11 kW",
    timeframe: "Vrsar",
  },
];
